/**
 * Imports various data processing modules and exports them as a single object.
 * This allows for easy access to all data processing functions from a single import.
 */

import * as combine_stats from './combine_stats.js';
import * as statistics from './statistics.js';
import * as number_of_data from './number_of_data.js';
import * as file from './file.js';
import * as ms_line_chart_group from './ms_line_chart_group.js';
import * as update_time from './update_time.js';
import * as tracking from "./tracking.js";

export default {
    combine_stats,
    statistics,
    number_of_data,
    file,
    ms_line_chart_group,
    update_time,
    tracking,
};
